import mergeDeep from "../../util/mergeDeep";
import sportenOpHetWerkApi from "../../api/sportenOpHetWerkApi";
export default class SportenOpHetWerkPageHelper {
    constructor(context, redirector) {
        this.context = context;
    }

    init() {
        let model = mergeDeep({}, this.context.state.sportenOpHetWerkModel);
        const { location } = this.context.props;
        const searchParams = new URLSearchParams(location.search);
        const initiatiefId = searchParams.get('initiatiefId');

        if (initiatiefId && this.context.props.initiatievenList) {
            const initiatief = this.context.props.initiatievenList.find(item => item.value === initiatiefId);
            if (initiatief) {
                model.initiatieven.push(initiatief.value);
            }
        }
        this.context.setState({
            sportenOpHetWerkModel: model
        });
    }

    change = (event) => this._change(event);
    changeHoofdZetel = (event) => this._change(event, "hoofdzetel");
    changeHoofdZetelAdres = (event) => this._change(event, "hoofdzetel", "adres");
    changeAanvraagAdresVestiging = (event) => this._change(event, "aanvraagAdresVestiging", "adres");
    changeContactPersoon = (event) => this._change(event, "contactPersoon");
    changeBedrijfInfo = (event) => this._change(event, "bedrijfInfo");

    changeCheckbox(event) {
        const property = event.target.name;
        const value = event.target.value;
        let model = mergeDeep({}, this.context.state.sportenOpHetWerkModel);
        model["aanvraagAdresVestiging"]["isNotIdem"] = value === "false" ? "true" : "false";
        this.context.setState({
            sportenOpHetWerkModel: model
        });
    }

    changeInitiatieven(event) {
        const property = event.target.name;
        const value = event.target.value;
        let model = mergeDeep({}, this.context.state.sportenOpHetWerkModel);

        if (!model.initiatieven.includes(value))
            model.initiatieven.push(value);
        else
            model.initiatieven.splice(model.initiatieven.indexOf(value), 1);

        this.context.setState({
            sportenOpHetWerkModel: model
        });
    }


    onSave() {
        const context = this.context;
        const state = context.state;
        const ajaxActions = context.props.ajaxActions;

        ajaxActions.started();
        return sportenOpHetWerkApi.save(state.sportenOpHetWerkModel)
            .then((response) => {
                ajaxActions.ended();
                if (Object.keys(response.data.validationResults).length === 0 && response.data.hasValidationErrors === false) {
                    this.context.setState({
                        sent: true,
                    });
                }
                this.context.setState({
                    errors: response.data.validationResults,
                });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }



    _change(event, subclass, subSubClass) {
        const property = event.target.name;
        const value = event.target.value;

        let model = mergeDeep({}, this.context.state.sportenOpHetWerkModel);
        if (subSubClass != null) {
            model[subclass][subSubClass][property] = value;
        } else if (subclass != null) {
            model[subclass][property] = value;
        } else
            model[property] = value;

        this.context.setState({
            sportenOpHetWerkModel: model
        });
    }


}